import React from 'react';
import {EditIcon, Flex, Menu, MoreIcon, ScreenshareIcon, SendIcon, TrashCanIcon} from '@fluentui/react-northstar';
import {duplicateDraftNotification, sendToMySelfDraftNotification} from '../../apis/messageListApi';
import {GenericDialog} from "../Dialogs/GenericDialog";
import SendConfirmationTaskModule from "../SendConfirmationTaskModule/sendConfirmationTaskModule";
import languageObject from "../../translations";
import {IDraftMessageSummary} from "../../Interfaces/IDraftMessageSummary";
import {AppContext, IAppContextState} from "../../services/AppContext";
import {withRouter, WithRouterProps} from "../../services/TelemetryService/withRouter.hook";

export interface OverflowProps extends WithRouterProps {
    message: IDraftMessageSummary;
    styles?: object;
    title?: string;
    selectMessage?: any;
    handleDelete: (id: string) => void;
    channelId: string;
    onDuplicateMessage: () => void;
    onMessageSent: () => void;
}

export interface OverflowState {
    menuOpen: boolean;
    showSendConfirmationDialog: boolean;
}

class Overflow extends React.Component<OverflowProps, OverflowState> {
    // Define component context
    static contextType = AppContext;
    context!: IAppContextState;

    constructor(props: OverflowProps) {
        super(props);
        this.state = {
            menuOpen: false,
            showSendConfirmationDialog: false,
        };
        this.handleMessageSent = this.handleMessageSent.bind(this);
        this.renderSendConfirmationDialog = this.renderSendConfirmationDialog.bind(this);
    }

    handleMessageSent() {
        this.setState({showSendConfirmationDialog: false});
        this.props.onMessageSent();
    }

    renderSendConfirmationDialog() {
        return (
            <GenericDialog
                title={languageObject.translate("Send") + " " + this.props.message.title}
                width={1000} height={700} show={this.state.showSendConfirmationDialog}
                onHide={this.handleMessageSent}>
                <SendConfirmationTaskModule
                    onMessageSent={this.handleMessageSent}
                    messageId={this.props.message.id}
                />
            </GenericDialog>
        )
    }

    public render(): JSX.Element {
        const items = [
            {
                key: 'more',
                icon: <MoreIcon className={"list-more-icon"} outline={true}/>,
                menuOpen: this.state.menuOpen,
                active: this.state.menuOpen,
                indicator: false,
                menu: {
                    items: [
                        {
                            key: 'send',
                            icon: <SendIcon outline/>,
                            content: languageObject.translate("Send"),
                            onClick: (event: any) => {
                                event.stopPropagation();
                                this.setState({
                                    menuOpen: false,
                                    showSendConfirmationDialog: true
                                });
                            }
                        },
                        {
                            key: 'sendToMyself',
                            icon: <SendIcon outline/>,
                            content: languageObject.translate("SendToMe"),
                            onClick: async (event: React.SyntheticEvent) => {
                                event.stopPropagation();
                                this.setState({
                                    menuOpen: false,
                                });
                                await this.SendToMySelf(this.props.message.id);
                            }
                        },
                        {
                            key: 'edit',
                            icon: <EditIcon outline/>,
                            content: languageObject.translate("Edit"),
                            onClick: (event: any) => {
                                event.stopPropagation();
                                this.props.navigate("/newmessage/" + this.props.message.id);
                            }
                        },
                        {
                            key: 'duplicate',
                            icon: <ScreenshareIcon outline/>,
                            content: languageObject.translate("Duplicate"),
                            onClick: async (event: React.SyntheticEvent) => {
                                event.stopPropagation();
                                this.setState({menuOpen: false});
                                await this.duplicateDraftMessage(this.props.message.id);
                            }
                        },
                        {
                            key: 'delete',
                            icon: <TrashCanIcon outline/>,
                            content: languageObject.translate("Delete"),
                            onClick: (event: any) => {
                                event.stopPropagation();
                                this.setState({
                                    menuOpen: false,
                                });
                                this.props.handleDelete(this.props.message.id)
                            }
                        },
                    ],
                },
                onMenuOpenChange: (event: any, {menuOpen}: any) => {
                    event.stopPropagation();
                    this.setState({
                        menuOpen: menuOpen
                    });
                },
            },
        ];

        return (
            <Flex onClick={(e: React.SyntheticEvent) => e.stopPropagation()}>
                {this.renderSendConfirmationDialog()}
                <Menu
                    onClick={(e: React.SyntheticEvent) => e.stopPropagation()}
                    className="menuContainer"
                    iconOnly
                    items={items}
                    styles={this.props.styles}
                    title={this.props.title}
                />
            </Flex>
        )
    }

    private duplicateDraftMessage = async (id: string) => {
        try {
            await duplicateDraftNotification(id);
            this.props.onDuplicateMessage();
        } catch (error) {
            return error;
        }
    }

    private SendToMySelf = async (id: string) => {
        try {
            await sendToMySelfDraftNotification(id);
        } catch (error) {
            return error;
        }
    }
}

export default withRouter(Overflow);